import * as React from 'react'
import Container from '@mui/material/Container'
import useCollapse from 'react-collapsed'
import CountUp from 'react-countup'
import VisibilitySensor from 'react-visibility-sensor'
import Title from './../title/title'
import DownloadPub from './../downloads/publications'
import Zoom from 'react-reveal/Zoom'
import Fade  from 'react-reveal/Fade'

const Region = ({ Json, regionId, children, svg, hidden }) => {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse()
  const large = {
    fontSize: '3em',
    display: 'block',
    lineHeight: 0.8,
    fontWeight: 'bold'
  }
  const conflict = {
    color: '#ef7c00',
    fontWeight: 'bold'
  }
  const disaster = {
    color: '#008dc9',
    fontWeight: 'bold'
  }
  const spotlights = []
  const spotlightsArr = Json[regionId].spotlight
  spotlightsArr.forEach((element, index) => {
    spotlights.push(
      <span key={index}>
        <DownloadPub name={element} suffix='Spotlight - '/>
        <br />
      </span>
    )
  })

  const hiddenPar = []
  if (hidden) {
    hidden.forEach((element, index) => {
      hiddenPar.push(<p key={index}>{element}</p>)
    })
  }
  return (
    <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
      {({ isVisible }) => (
        <Container maxWidth='lg' className='border p-3 mb-5'>
          <div className='row d-flex align-items-end'>
            <div className='col-md-8'>
              <h4>{Json[regionId].title} </h4>
              <Fade left>
        <div className='underline'></div>
      </Fade>
              {isVisible ? (
                <div className='row'>
                  <div className='col-md-6 text-center my-3'>
                    {' '}
                    <CountUp
                      end={Json[regionId].conflict[0]}
                      suffix={Json[regionId].conflict[1]}
                      duration={1}
                      separator={Json.separator}
                      decimals={Json[regionId].conflict[2]}
                      decimal={Json.decimal}
                      style={{ ...large, ...conflict }}
                    />
                    <span style={conflict}>{Json.conflict}</span>
                  </div>
                  <div className='col-md-6 text-center my-3'>
                    <CountUp
                      end={Json[regionId].disasters[0]}
                      suffix={Json[regionId].disasters[1]}
                      duration={1}
                      separator={Json.separator}
                      decimals={Json[regionId].disasters[2]}
                      decimal={Json.decimal}
                      style={{ ...large, ...disaster }}
                    />
                    <span style={disaster}>{Json.disasters}</span>
                  </div>
                </div>
              ) : null}
            </div>

            <div className='col-md-4 text-center pb-3'>
              <Zoom>
                <img
                  src={svg}
                  style={{ width: '100%', maxWidth: '150px' }}
                  alt={Json[regionId].title}
                />
              </Zoom>
              {/* <embed
                type='image/svg+xml'
                src={svg}
                width='100%'
                height='700'
                style={{ height: 'auto' }}
                className={isVisible ? 'animated' : null}
                id='ssa'
              ></embed> */}
            </div>
          </div>
          {children}
          {hidden ? (
            <>
              <section {...getCollapseProps()}>{hiddenPar}</section>
              <button
                style={{ background: '#0a3758', color: '#ffffff', border: '0', borderRadius: '5px', padding: '5px 10px' }}
                {...getToggleProps()}
              >
                {isExpanded ? 'Read less' : 'Read more'}
              </button>
            </>
          ) : null}
          <p>
            <DownloadPub
              name={Json[regionId].link}
              suffix='Regional Overview - '
            />
            <br />
            {spotlights}
          </p>
        </Container>
      )}
    </VisibilitySensor>
  )
}

export default Region
